module.exports = _mano_registry["react"];